import { render } from "./PasswordForgotForm.vue?vue&type=template&id=6232ad95"
import script from "./PasswordForgotForm.vue?vue&type=script&lang=js"
export * from "./PasswordForgotForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__